import { render, staticRenderFns } from "./FloatFrameAddBtn.vue?vue&type=template&id=028f3200&"
import script from "./FloatFrameAddBtn.vue?vue&type=script&lang=js&"
export * from "./FloatFrameAddBtn.vue?vue&type=script&lang=js&"
import style0 from "./FloatFrameAddBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports